import reducer from "./reducer";
export { default as GridProcessResultDialog } from "./components/index";
export { default as gridProcessResultDialogReducerName } from "./constants";
export default reducer;
